import { IButtonProps, IButtonStyles, IconButton, IStyle } from "@fluentui/react";
import React from "react";

export type FormClearButtonProps = Pick<IButtonProps, "onClick" | "disabled"> & { testId?: string };

export const FormClearButton: React.FunctionComponent<FormClearButtonProps> = (props: FormClearButtonProps) => {
    const clearButtonRootStyle: IStyle = { position: "absolute", top: 30, right: 30, background: "transparent" };
    const clearButtonIconStyle: IStyle = { fontSize: 12 };

    const clearIconButtonStyle: IButtonStyles = {
        root: clearButtonRootStyle,
        rootHovered: clearButtonRootStyle,
        rootPressed: clearButtonRootStyle,
        rootDisabled: clearButtonRootStyle,
        icon: clearButtonIconStyle
    };

    return (
        <IconButton
            iconProps={{ iconName: "Cancel" }}
            styles={clearIconButtonStyle}
            disabled={props.disabled}
            onClick={props.onClick}
            data-testId={props.testId}
        />
    );
};
